import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide07NavComStats.css';

const experienceRows = [
  { label: '10+ years', value: 41, width: 67 },
  { label: '5+ years', value: 61, width: 100 },
  { label: '3+ years', value: 41, width: 67 },
  { label: '1+ years', value: 37, width: 61 },
];

function Slide07NavComStats() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 20 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-navcom-stats">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="navcom-stats-bg">
        <div className="navcom-stats-grid" />
        <div className="navcom-stats-lines" />
        <div className="navcom-stats-noise" />
      </div>

      <div className="navcom-stats-content">
        <motion.div className="navcom-stats-header" {...fadeUp(0.05)}>
          NAV &amp; COM
        </motion.div>

        <div className="navcom-stats-grid-layout">
          <motion.div className="navcom-card navcom-card-wide" {...fadeUp(0.15)}>
            <div className="navcom-card-title">180+</div>
            <div className="navcom-card-subtitle">Service Engineers</div>
          </motion.div>

          <motion.div className="navcom-card navcom-card-small" {...fadeUp(0.2)}>
            <div className="navcom-card-label">SEAMAN BOOK &amp; WORKING VISA</div>
            <div className="navcom-card-value">40+</div>
          </motion.div>

          <motion.div className="navcom-card navcom-card-small" {...fadeUp(0.25)}>
            <div className="navcom-card-label">GOC CERTIFICATE HOLDERS</div>
            <div className="navcom-card-value">50+</div>
          </motion.div>

          <motion.div className="navcom-card navcom-card-profile" {...fadeUp(0.18)}>
            <div className="navcom-card-label">EXPERIENCE PROFILE</div>
            <div className="navcom-profile-list">
              {experienceRows.map((row, index) => (
                <div key={row.label} className="navcom-profile-row">
                  <div className="navcom-profile-top">
                    <span>{row.label}</span>
                    <span>{row.value}</span>
                  </div>
                  <div className="navcom-profile-track">
                    <motion.span
                      className="navcom-profile-fill"
                      style={{ width: `${row.width}%` }}
                      initial={{ scaleX: reduceMotion ? 1 : 0 }}
                      animate={{ scaleX: 1 }}
                      transition={{ duration: 0.8, delay: 0.25 + index * 0.1, ease }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div className="navcom-card navcom-card-note" {...fadeUp(0.3)}>
            More than 40 of our personnel hold Seaman&apos;s Books, and over 50 are certified with GOC Certificates.
          </motion.div>

          <motion.div className="navcom-card navcom-card-wide navcom-card-resp" {...fadeUp(0.35)}>
            <div className="navcom-card-label">TEAM RESPONSIBILITY</div>
            <p className="navcom-card-text">
              The Navigation Team is responsible for the design, integration, commissioning, maintenance, and repair of
              marine navigation systems, ensuring safe and reliable vessel operation.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Slide07NavComStats;
